"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Content = require("./Content");
Object.keys(_Content).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Content[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Content[key];
    }
  });
});